<div class="program-header">
  <div class="program-header__top">
    <h1 class="program-header__title headline5">{{ displayTitle }}</h1>

    <ptl-button
      *ngIf="canEdit"
      type="primary-pink"
      [text]="'translations.programs.edit.editContent' | transloco"
      [icon]="Pen01Icon"
      (click)="editClicked.emit()"
    ></ptl-button>
  </div>

  <div class="card-view__report-container" *ngIf="report">
    <ptl-playlist-report #playlistReportComponent [report]="report" (pdfDownloaded)="onReportDownloaded()" (pdfError)="onReportPdfError()">
    </ptl-playlist-report>
  </div>
  <div class="program-header__actions">
    <div class="left-side">
      <ptl-button
        type="secondary-neutral"
        [text]="'translations.global.button.save' | transloco"
        [icon]="$any(program)?.favorite ? Bookmark02Icon : BookmarkCheck02Icon"
        (click)="saveItem()"
      ></ptl-button>

      <ptl-button
        type="secondary-neutral"
        [text]="'translations.global.button.download' | transloco"
        [icon]="Download04Icon"
        (click)="downloadReport()"
      >
        <mat-spinner *ngIf="downloadInProgress" [diameter]="20"></mat-spinner>
      </ptl-button>
    </div>
    <div class="right-side">
      <ptl-button
        type="secondary-neutral"
        [text]="'translations.global.button.language' | transloco"
        [icon]="LanguageSquareIcon"
        [iconSuffix]="ArrowDown01Icon"
        [matMenuTriggerFor]="languageMenu"
        *ngIf="availableLanguages?.length > 1"
      ></ptl-button>

      <mat-menu #languageMenu="matMenu">
        <button
          mat-menu-item
          *ngFor="let language of availableLanguages"
          class="language-menu-item"
          [class.is_active]="language.code === selectedLanguageCode"
          [attr.aria-label]="'translations.global.ariaLabels.icons.changeLanguageTo' | transloco: { lang: language.name }"
          (click)="languageSelect(language.code)"
          [value]="language.code"
        >
          {{ language.code.toUpperCase() }}
        </button>
      </mat-menu>

      <ptl-button
        type="secondary-neutral"
        [text]="'translations.global.button.share' | transloco"
        [icon]="Share08Icon"
        (click)="shareProgram()"
      ></ptl-button>
    </div>
  </div>
</div>
